import { useState } from 'react';
import { rankGroups } from '@/mocks/homeData';

export default function HotRank() {
  const [active, setActive] = useState(rankGroups[0]);
  const group = active ?? rankGroups[0];

  return (
    <section id="hot" className="scroll-mt-20 bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold tracking-widest text-primary-600">话题热度</span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              热门大瓜榜<span className="text-primary-600">谁在领跑</span>
            </h2>
            <p className="mt-3 text-base text-foreground-600 md:text-lg">
              综合讨论量与扩散速度给出的热度参考，帮你看清本周到整季的话题走向。
            </p>
          </div>

          {/* tabs */}
          <div className="inline-flex self-start rounded-full border border-background-300 bg-background-50 p-1 md:self-auto">
            {rankGroups.map((g) => (
              <button
                key={g.key}
                type="button"
                onClick={() => setActive(g)}
                className={`rounded-full px-5 py-2 text-sm font-medium transition ${
                  group.key === g.key
                    ? 'bg-primary-500 text-background-50 shadow-md shadow-primary-500/20'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {group.items.map((item) => {
            const maxHeat = group.items[0].heat;
            const ratio = (parseFloat(item.heat) / parseFloat(maxHeat)) * 100;
            const isTop3 = item.no <= 3;
            return (
              <article
                key={`${group.key}-${item.id}`}
                className={`flex items-center gap-4 rounded-xl border bg-background-50 p-4 transition hover:border-primary-200 md:p-5 ${
                  isTop3 ? 'border-background-200' : 'border-background-200'
                }`}
              >
                <div
                  className={`font-latin flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-2xl ${
                    item.no === 1
                      ? 'bg-accent-500 text-foreground-950'
                      : isTop3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {item.no}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    <span className="whitespace-nowrap text-xs text-foreground-400">{item.tag}</span>
                    <span
                      className={`flex items-center gap-0.5 text-xs ${
                        item.trend === 'up'
                          ? 'text-primary-600'
                          : item.trend === 'down'
                            ? 'text-secondary-500'
                            : 'text-foreground-400'
                      }`}
                    >
                      <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'} text-sm`} />
                      {item.trend === 'up' ? '升温' : item.trend === 'down' ? '降温' : '持平'}
                    </span>
                  </div>
                  <h3 className="mt-0.5 truncate font-medium text-foreground-900 md:text-base">{item.title}</h3>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-100">
                      <div
                        className={`h-full rounded-full ${item.no === 1 ? 'bg-accent-400' : 'bg-primary-500/70'}`}
                        style={{ width: `${ratio}%` }}
                      />
                    </div>
                    <span className="whitespace-nowrap text-xs font-medium text-foreground-500">
                      {item.heat}
                      <span className="text-foreground-400">w</span>
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}